import React from 'react';
import classNames from 'classnames';

const Listitem = (props) => {
  return (
    <li
      className={classNames({
        'card-link-list__list-item': true,
        'full-width': props.fullWidth,
      })}>
      <a className={`card-link-list__link ${props.matomoTrackingClass ? props.matomoTrackingClass : ''}`} href={props.Url}>
        <span>{props.Text}</span>
      </a>

      {props.itemChildren && props.itemChildren(props)}
    </li>
  );
};

const List = (props) => {
  if (!props.items) return null;
  return (
    <div
      className={classNames({
        'card-link-list': true,
        ...props.modifiers,
      })}
    >
      <ul className="card-link-list__list">
        {props.items.map((item, key) => (
          <Listitem
            {...item}
            itemChildren={props.itemChildren}
            key={key}
            fullWidth={props.fullWidth}
            matomoTrackingClass={props.matomoTrackingClass}
          />
        ))}
        {!props.fullWidth && props.items.length % 2 !== 0 && (
          <li key="fill" className="card-link-list__list-item empty">
            <span tabIndex="-1"></span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default List;
